import React, { useState } from "react";
import { Box, Flex, Text, useColorModeValue, Container, HStack, Tag, Heading  } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import TEMSeminar from "./TEMSeminar";
import TTESeminar from "./TTESeminar";


function TraversalSeminarHeader() {
  const accent = "#06B6D4";
  const accent2 = "#22D3EE";

  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const titleColor = useColorModeValue("#0F172A", "white");
  const subColor = useColorModeValue("gray.700", "gray.300");

  const heroBg = useColorModeValue(
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.18), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(2,6,23,0.02), rgba(2,6,23,0.00))",
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.20), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.00))"
  );

  return (
    <Box
      pt={{ base: 6, md: 8 }}
      pb={{ base: 8, md: 10 }}
      bg={heroBg}
      borderBottom="1px solid"
      borderColor={border}
    >
      <Container maxW="1200px">
        <HStack spacing={2}>
          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("white", "rgba(255,255,255,0.06)")}
            border="1px solid"
            borderColor={border}
            fontWeight="800"
          >
            University of Ottawa
          </Tag>

          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("rgba(6,182,212,0.12)", "rgba(6,182,212,0.18)")}
            color={useColorModeValue("#0E7490", "#67E8F9")}
            fontWeight="900"
          >
            TRAVERSAL
          </Tag>
        </HStack>

        <Heading
          mt={4}
          fontSize={{ base: "3xl", md: "4xl" }}
          color={titleColor}
          letterSpacing="tight"
        >
          <Box
            as="span"
            bgClip="text"
            bgGradient={`linear(to-r, ${accent}, ${accent2})`}
          >
            TRAVERSAL
          </Box>{" "}
          Seminars
        </Heading>

        <Text
          mt={3}
          color={subColor}
          fontSize={{ base: "md", md: "lg" }}
          maxW="85ch"
          lineHeight={1.8}
        >
          The TRAVERSAL seminars will cover a wide array of topics, including cutting-edge developments in various fields of research, technology transfer, 
          and entrepreneurship. Featuring distinguished speakers from around the globe, the seminars offer a unique opportunity for knowledge-sharing, collaboration, 
          and networking. 
        </Text>
      </Container>
    </Box>
  );
}


function Technical() {
  const isMobile = useSelector((state) => state.windowSize.isMobile);
  const [active, setActive] = useState("TEM");

  const contentAlign = isMobile ? "center" : "left";

  return (
    <>
      <TraversalSeminarHeader />

      <Box maxW="1200px" mx="auto" px={isMobile ? 4 : 0} pt={isMobile ? 2 : 4} pb={12}>
        {/* -------- Segmented Toggle (small visual upgrade) -------- */}
        <Flex
          w="100%"
          mb={6}
          p="6px"
          border="1px solid"
          borderColor="rgba(0,0,0,0.12)"
          borderRadius="full"
          bg="rgba(0,0,0,0.03)"
          gap="6px"
          flexDir={{ base: "column", md: "row" }} // better on mobile
        >
          <Flex
            flex="1"
            justify="center"
            align="center"
            textAlign="center"
            px={4}
            py={3}
            cursor="pointer"
            fontWeight="700"
            borderRadius="full"
            bg={active === "TEM" ? "white" : "transparent"}
            boxShadow={active === "TEM" ? "0 6px 18px rgba(0,0,0,0.10)" : "none"}
            transition="all 180ms ease"
            onClick={() => setActive("TEM")}
          >
            TECHNICAL - ETHICAL MENTORSHIP SEMINAR SERIES
          </Flex>

          <Flex
            flex="1"
            justify="center"
            align="center"
            textAlign="center"
            px={4}
            py={3}
            cursor="pointer"
            fontWeight="700"
            borderRadius="full"
            bg={active === "TTE" ? "white" : "transparent"}
            boxShadow={active === "TTE" ? "0 6px 18px rgba(0,0,0,0.10)" : "none"}
            transition="all 180ms ease"
            onClick={() => setActive("TTE")}
          >
            TECHNOLOGY TRANSFER ENTREPRENEURSHIP
          </Flex>
        </Flex>

        {/* -------- Content (small visual upgrade) -------- */}
        {active === "TEM" ? (
          <>
            <Box
              borderRadius="16px"
              p={isMobile ? 4 : 6}
              mb={6}
              bg="white"
              border="1px solid"
              borderColor="rgba(0,0,0,0.08)"
              boxShadow="0 10px 24px rgba(0,0,0,0.06)"
            >
              <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={3}>
                TECHNICAL - ETHICAL MENTORSHIP SEMINAR SERIES
              </Text>

              <Text textAlign={contentAlign} lineHeight="1.8" color="gray.700">
                <b>The Technical-Ethical Mentorship Seminar Series</b>, abbreviated as TEM, is an
                integral component of the TRAVERSAL program. This series provides trainees with
                valuable insights into the latest technical advancements in the field of autonomous
                vehicles (AVs) and uncrewed aerial vehicles (UAVs). Additionally, TEM addresses the
                legal and ethical dimensions associated with AV and UAV-based services. It consists
                of a minimum of eight seminars per year, ensuring that trainees receive
                comprehensive knowledge and guidance in both technical and ethical aspects of their
                field. Through TEM, trainees gain a well-rounded understanding of the complex and
                evolving landscape of AV and UAV technologies.
              </Text>
            </Box>

            <TEMSeminar />
          </>
        ) : (
          <>
            <Box
              borderRadius="16px"
              p={isMobile ? 4 : 6}
              mb={6}
              bg="white"
              border="1px solid"
              borderColor="rgba(0,0,0,0.08)"
              boxShadow="0 10px 24px rgba(0,0,0,0.06)"
            >
              <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={3}>
                TECHNOLOGY TRANSFER ENTREPRENEURSHIP
              </Text>

              <Text textAlign={contentAlign} lineHeight="1.8" color="gray.700">
                <b>The Technology Transfer Entrepreneurship</b> aspect of the TRAVERSAL program
                focuses on equipping trainees with the knowledge and skills required for successful
                technology readiness and commercialization. This segment provides strategies for
                taking research outcomes from the program and translating them into viable
                commercial products or services. Trainees receive seminar support through
                technology transfer offices and benefit from the expertise of alumni from startup
                accelerators. To ensure comprehensive training, trainees are required to attend a
                minimum of four seminars in each stream per year. This emphasis on technology
                transfer and entrepreneurship empowers trainees to effectively navigate the journey
                from research to real-world applications, fostering innovation and economic impact.
              </Text>
            </Box>

            <TTESeminar />
          </>
        )}
      </Box>
    </>
  );
}


export default Technical;
